import { connect } from "react-redux";
import "../../exam/pages/ExamPage.css";
import ExerciseTestScreen from "../components/ExerciseTestScreen";
import usePreventUnload from "../../../../shared/hooks/usePreventUnload";
import LoaderPopUp from "../../../loader/loader";

const ExerciseExamPage = ({ loader }) => {
  usePreventUnload("You cannot leave this page during the test!");

  return (
    <div className="exam_page_wrapper">
      <ExerciseTestScreen />
      {loader && <LoaderPopUp />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
  };
};

export default connect(mapStateToProps)(ExerciseExamPage);
